import moment from 'moment';

const calculateNextStudyDate  = (dateOftest: string, validTimeInMinutes: number) => {
    return moment(dateOftest).add(validTimeInMinutes, 'minutes').format('YYYY-MM-DD h:mm');
}

export default calculateNextStudyDate;